// extracted by mini-css-extract-plugin
export var active = "_s-8";
export var addWidgetButton = "_s-9";
export var backButton = "_s-1";
export var pageContainer = "_s-2";
export var settingsContent = "_s-0";
export var sideNavContainer = "_s-6";
export var sideNavLink = "_s-7";
export var widgetContainer = "_s-5";
export var widgetSubsectionItem = "_s-3";
export var widgetSubsectionItemContent = "_s-4";